import { http, HttpResponse } from 'msw'

interface MockUpdateAgencyChainResponsibleDataPathParams {
  agencyChainAlphaId: string
}

interface MockUpdateAgencyChainResponsibleDataBody {
  responsibleData: {
    companyPosition?: string
    name: string
    responsibleTaxpayerId: string
  }
}

export const mockUpdateAgencyChainResponsibleData = http.patch<
  MockUpdateAgencyChainResponsibleDataPathParams,
  MockUpdateAgencyChainResponsibleDataBody
>(
  '/my-business/api/agency/v1/agency-chains/:agencyChainAlphaId',
  async ({ request }) => {
    const body = await request.json()

    if (body.responsibleData.name === 'error') {
      const error = {
        message: 'E001',
        detail: 'Some error message',
      }
      return HttpResponse.json({ error }, { status: 400 })
    }

    return HttpResponse.json(null, { status: 200 })
  },
)
